import React, { Component, ReactNode } from 'react'
import NotFound from './views/NotFound'

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor (props: Props | Readonly<Props>) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError (error: any) {
    console.log(error)
    return { hasError: true }
  }

  componentDidCatch (error: any, errorInfo: any) {
    console.log(error, errorInfo)
  }

  render () {
    if (this.state.hasError) {
      return (
          <div style={{ background: 'white' }}>
              <NotFound />
          </div>
      )
    }

    return (
      <React.Fragment>
      {this.props.children}
    </React.Fragment>
    )
  }
}

export default ErrorBoundary
